/**
 * Object to display in ProductDetailComponent
 */
class Track {
  /**
     * @param {string} number
     * @param {string} title
     * @param {string | null} work
     * @param {string | null} soundUrl
     * @param {string | null} duration
     * @param {number} songIndex - internal index of each playable song
     */
  constructor (number, title, work, soundUrl, duration, songIndex) {
    this.number = number
    this.title = title
    this.work = work
    this.soundUrl = soundUrl
    this.duration = duration
    this.songIndex = songIndex
  }
}

export default Track
